import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "32_tag-box.svg",
  "use": "32_tag-box.svg-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"32_tag-box.svg\"><rect width=\"32\" height=\"32\" transform=\"translate(0 32) rotate(-90)\" style=\"fill:none\" /><path d=\"M27.8,4.2l-8.74-.45L3.86,19l9.19,9.19,15.2-15.2ZM25.07,9.76a2,2,0,1,1,0-2.83A2,2,0,0,1,25.07,9.76Z\" style=\"fill:#83beec;stroke:#0063b1;stroke-miterlimit:10\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol